import { Transforms } from 'slate';
import { NESTED_LIST_PATH_INDEX } from "../constants.js";

/**
 * Nests (moves) given "list" in a given "list-item".
 */
export function moveListToListItem(editor, parameters) {
  var [sourceListNode, sourceListPath] = parameters.at;
  var [targetListNode, targetListPath] = parameters.to;

  if (!editor.isListNode(sourceListNode) || !editor.isListItemNode(targetListNode)) {
    // Sanity check.
    return;
  }

  Transforms.moveNodes(editor, {
    at: sourceListPath,
    to: [...targetListPath, NESTED_LIST_PATH_INDEX]
  });
}